import {createStore, applyMiddleware, compose} from 'redux'
import thunk from 'redux-thunk'

import logger from "../middlewares/logger";

const initialState={
    house : {
        name : "Welcome to Hogwarts Student Index!",
        members : [],
        comments : []
    },
    person : {},
    spells : [],
    favouriteSpells : []
}

const reducer = (state = initialState, action) => {
    switch(action.type){
        case "GET_HOUSE_DETAIL" :
            console.log('masuk GET_HOUSE_DETAIL ', action)
            return {...state, house : action.data[0]}
        case "GET_PERSON_DETAIL" : 
            console.log('masuk GET_PERSON_DETAIL', action)
            console.log(action)
            return {...state, person : action.person}
        case "GET_SPELLS" : 
            console.log('masuk GET_SPELLS', action)
            return {...state, spells : action.spells}
        case "SET_FAVOURITE_SPELLS" : 
            console.log('masuk GET_FAVOURITE_SPELLS', action)
            return {...state, favouriteSpells : [ ...state.favouriteSpells, action.favSpells]}
        case "DELETE_FAVOURITE_SPELLS" : 
            console.log('masuk GET_FAVOURITE_SPELLS', action)
            return {...state, favouriteSpells : state.favouriteSpells.filter(el => el.spell !== action.spell)}
        default:
            return state
    }
}

const store = createStore (
        reducer, 
        compose (
            applyMiddleware(thunk,logger)
        )
    )

export default store